<template>
  <div v-if="actions.length" class="banner-actions">
    <template v-if="actions.includes('cookieModalBtn')">
      <CookeModalBtn class="banner-actions__cookie-btn" />
    </template>
  </div>
</template>

<script>
import CookeModalBtn from './CookeModalBtn.vue'

export default {
  name: 'BannerActions',
  components: {
    CookeModalBtn,
  },
  data() {
    return {
      actions: [],
    }
  },
  created() {
    switch (this.$route.params?.id) {
      case 'politika_ispol_zovaniya_faylov_cookie':
        this.actions.push('cookieModalBtn')
    }
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/ui-components/banner/components/BannerActions.vue